import { Pipe, PipeTransform } from '@angular/core';
import { SecurityContextService } from '@services/security_context.service';

@Pipe({
  name: 'auth',
  pure: false,
})
export class AuthImpurePipe implements PipeTransform {
  constructor(private _securityContextService: SecurityContextService) {}

  transform(_: any, role?: string): boolean {
    if (role === 'trusted') {
      return this._securityContextService.isTrustedUser();
    }

    return this._securityContextService.isLoggedIn();
  }
}
